export interface CarrierStateFields {
  LiveShipmentStatus?: string | null;
  LiveShipmentStatusTranslated?: string | null;
  ExternalShipmentOrderNumber?: string | null;
  NeedsPmSignOff?: boolean;
  CanRebook?: boolean;
  RebookWarning?: string | null;
  // The courier's reason for rejecting the shipment (Wadily Rejected webhook).
  RejectionMessage?: string | null;
  // The last failed courier booking; cleared by a successful mark-ready, Retry or Re-book.
  LastBookingError?: string | null;
}

export const WADILY_LIVE_STATUS = {
  UnRead: 'UnRead',
  Accepted: 'Accepted',
  OnTheWayToPickup: 'OnTheWayToPickup',
  Delivering: 'Delivering',
  Delivered: 'Delivered',
  Rejected: 'Rejected',
} as const;
